// English translations


export const en = {
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    none: 'None',
    yes: 'Yes',
    no: 'No',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    confirm: 'Confirm',
    required: 'Required',
    optional: 'Optional',
    scroll: 'Scroll',
  },

  // Navigation
  nav: {
    home: 'Home',
    book: 'Book',
    myRaces: 'My Races',
    sites: 'Our Sites',
    faq: 'FAQ',
    contact: 'Contact',
    bookNow: 'Book Now',
    login: 'Login',
    logout: 'Logout',
    profile: 'My Profile',
  },

  // Hero Section
  hero: {
    newInCorsica: 'New in Corsica!',
    title: 'Boat Racing Experience',
    subtitle: 'Experience 100% immersive racing! Pilot FPV boats with an onboard camera view on the water.',
    sensations: 'Thrills guaranteed.',
    bookRace: 'Book My Race',
    discoverConcept: 'Discover the Concept',
    stats: {
      speed: 'km/h',
      pilots: 'pilots',
      minutes: 'minutes',
      funGuaranteed: 'fun guaranteed',
    },
  },

  // Concept Section
  concept: {
    badge: 'THE CONCEPT',
    title: 'FPV Racing on Water',
    subtitle: 'Imagine piloting a high-speed racing boat with an onboard view as if you were on board. That\'s Aqua-Rush!',
    features: {
      piloting: {
        icon: '🎮',
        title: 'Intuitive Piloting',
        desc: 'Ergonomic remote control and responsive boats. Accessible from age 8!',
      },
      immersive: {
        icon: '🥽',
        title: 'Immersive View',
        desc: 'Headset or screen to dive into the cockpit. You see what the boat sees!',
      },
      competition: {
        icon: '🏁',
        title: 'Thrilling Competition',
        desc: 'Up to 4 pilots race each other on the water circuit. Who will be fastest?',
      },
      memories: {
        icon: '📸',
        title: 'Memorable Moments',
        desc: 'Your times, photos and achievements to share on social media!',
      },
    },
  },

  // How It Works
  howItWorks: {
    badge: 'HOW IT WORKS',
    title: 'On your way to',
    titleHighlight: 'victory',
    cta: 'Let\'s go, I\'m booking!',
    subtitle: 'From booking to podium, it\'s easy as pie!',
    steps: {
      book: {
        icon: '📱',
        num: '01',
        title: 'Book',
        desc: 'Choose your slot and pay in a few secure clicks.',
      },
      install: {
        icon: '🎯',
        num: '02',
        title: 'Briefing',
        desc: '5 min to master the controls with our team.',
      },
      race: {
        icon: '🏁',
        num: '03',
        title: 'Race time',
        desc: '5 min of intense racing with 5 timed laps.',
      },
      win: {
        icon: '🏆',
        num: '04',
        title: 'Celebrate',
        desc: 'Podium, photos and times. Memorable memories.',
      },
    },
  },

  // Pricing
  pricing: {
    badge: 'OUR PRICING',
    title: 'Thrills at',
    titleHighlight: 'smart prices',
    description: 'Choose the plan that suits you. Everything included!',
    note: '💳 Secure payment • 🔄 Free cancellation up to 24h before',
    plans: [
      { name: 'Solo', desc: 'One race, one experience', price: 15, features: ['1 race of 5 minutes', '5 timed laps', 'FPV headset provided', 'Online time access'], popular: false },
      { name: 'Duo Pack', desc: 'Better together!', price: 25, priceNote: 'for 2 people', features: ['2 races of 5 minutes', 'Challenge each other!', 'FPV headsets provided', 'Souvenir photos', 'Online time access'], popular: true },
      { name: 'Team 4', desc: 'Ultimate fun with friends', price: 45, priceNote: 'for 4 people', features: ['4 races of 5 minutes', 'Battle royale for 4!', 'FPV headsets provided', 'Photos & videos', 'Custom podium', 'Race replay'], popular: false },
    ],
    cta: 'Book',
    popular: 'Popular',
  },

  // Features
  features: {
    badge: 'WHY CHOOSE US',
    title: 'An unforgettable',
    subtitle: 'experience',
    items: {
      fun: {
        icon: '🎉',
        title: 'Guaranteed Fun',
        desc: 'An original and accessible activity for everyone, from 8 to 88 years old!',
      },
      tech: {
        icon: '📡',
        title: 'FPV Technology',
        desc: 'Total immersion with HD onboard camera and real-time transmission.',
      },
      competition: {
        icon: '🏆',
        title: 'Competition',
        desc: 'Rankings, personal records, podiums. Who will be the champion?',
      },
      social: {
        icon: '👨‍👩‍👧‍👦',
        title: 'Shared Moments',
        desc: 'Perfect with friends, family or for corporate events.',
      },
      outdoor: {
        icon: '🎁',
        title: 'Group packages',
        desc: 'Birthdays, bachelor parties, team building: we adapt.',
      },
      safe: {
        icon: '🛡️',
        title: 'Maximum Safety',
        desc: 'Professional equipment and supervision by our experts.',
      },
    },
  },

  // Video
  video: {
    badge: 'IN ACTION',
    title: 'See for',
    titleHighlight: 'yourself',
    subtitle: 'Dive into the action with our FPV racing videos!',
    close: 'Close',
    videos: [
      { title: 'Intense FPV race' },
      { title: 'Guaranteed thrills' },
    ],
  },

  // Testimonials
  testimonials: {
    badge: 'TESTIMONIALS',
    title: 'They',
    titleHighlight: 'loved it',
    list: [
      { name: 'Thomas M.', location: 'Paris', avatar: '👨', text: 'An incredible experience! We did this with the kids, they still talk about it. FPV sensations are truly unique.' },
      { name: 'Sophie L.', location: 'Lyon', avatar: '👩', text: 'Perfect for an original bachelorette party! We laughed, we teased each other, the staff was great. I recommend 1000%!' },
      { name: 'Marc D.', location: 'Marseille', avatar: '🧔', text: 'Former FPV drone pilot, I loved the water concept. It\'s even more fun! Can\'t wait for the next one.' },
      { name: 'Julie R.', location: 'Bordeaux', avatar: '👧', text: 'My 10-year-old son beat his father! The giant screen with the ranking is great for the atmosphere.' },
    ],
    stats: { rating: '4.9/5', onGoogle: 'on Google', races: 'races', satisfied: 'satisfied' },
  },

  // Sites
  sites: {
    badge: 'OUR LOCATIONS',
    title: 'Where to',
    titleHighlight: 'find us',
    subtitle: 'Exceptional locations for memorable races',
    open: 'Open',
    comingSoon: 'Soon',
    opening: 'Coming soon',
    viewDetails: 'See all our locations',
    bookNow: 'Book here',
    list: [
      { slug: 'porto-vecchio', name: 'Porto-Vecchio', location: 'South Corsica', image: '🏝️', desc: 'In the heart of the Salt City, enjoy an exceptional setting with sea view.', status: 'open', features: ['Sea view', 'Free parking', 'Bar on site'] },
      { slug: 'saint-tropez', name: 'Saint-Tropez', location: 'Var', image: '⛵', desc: 'On the legendary port, an FPV experience in a postcard setting.', status: 'soon', features: ['Marina', 'Restaurant', 'Terrace'] },
      { slug: 'biarritz', name: 'Biarritz', location: 'Pyrénées-Atlantiques', image: '🏄', desc: 'The Basque spirit meets FPV technology for unique sensations.', status: 'soon', features: ['Beach', 'Surf nearby', 'Festive atmosphere'] },
    ],
  },

  // FAQ
  faq: {
    badge: 'FAQ',
    title: 'Frequently Asked Questions',
    subtitle: 'Everything you need to know',
    questions: [
      {
        q: 'What is the minimum age to pilot?',
        a: 'The activity is accessible from age 8. Children under 12 must be accompanied by an adult.',
      },
      {
        q: 'How long does a race last?',
        a: 'A standard race lasts 7 minutes. That\'s enough time for several laps and plenty of thrills!',
      },
      {
        q: 'Do I need experience?',
        a: 'No! A 2-minute briefing explains the controls. It\'s accessible to all skill levels.',
      },
      {
        q: 'Can I book for a group?',
        a: 'Yes! We offer group packages and private sessions for birthdays, bachelor/bachelorette parties and corporate events.',
      },
      {
        q: 'What happens if there\'s a breakdown?',
        a: 'Our boats are regularly maintained. In case of technical issues, you\'ll be refunded or redirected to another session.',
      },
      {
        q: 'Can I cancel my booking?',
        a: 'Yes, free cancellation up to 24 hours before. See our Terms & Conditions for more details.',
      },
    ],
    moreQuestions: 'Have other questions?',
    contactUs: 'Contact us',
  },

  // Booking
  booking: {
    title: 'Book',
    subtitle: 'Choose your time slot',
    selectSite: 'Select a site',
    selectDate: 'Choose a date',
    selectTime: 'Choose a time',
    selectFormula: 'Choose your package',
    participants: 'Number of participants',
    yourInfo: 'Your information',
    name: 'Full name',
    email: 'Email',
    phone: 'Phone',
    notes: 'Notes (optional)',
    total: 'Total',
    pay: 'Pay',
    confirmBooking: 'Confirm booking',
    bookingConfirmed: 'Booking confirmed!',
    bookingCode: 'Booking code',
    checkEmail: 'You will receive a confirmation email.',
  },

  // My Races
  myRaces: {
    title: 'My Races',
    subtitle: 'Your history and statistics',
    noRaces: 'You haven\'t participated in any races yet.',
    bookFirst: 'Book my first race',
    totalRaces: 'Total races',
    bestLap: 'Best lap',
    avgPosition: 'Average position',
    history: 'History',
    date: 'Date',
    site: 'Site',
    position: 'Position',
    lapTime: 'Lap time',
  },

  // Contact
  contact: {
    badge: 'CONTACT',
    title: 'Have a Question?',
    subtitle: 'Our team will respond quickly',
    form: {
      name: 'Your name',
      email: 'Your email',
      subject: 'Subject',
      message: 'Your message',
      send: 'Send',
      sending: 'Sending...',
      sent: 'Message sent!',
      error: 'Error sending message',
    },
    info: {
      title: 'Information',
      email: 'Email',
      emailAddress: 'contact@aqua-rush.fr',
      phone: 'Phone',
      phoneNumber: '+33 4 XX XX XX XX',
      address: 'Address',
      addressLine: 'Porto-Vecchio, Corsica',
    },
    social: {
      title: 'Follow Us',
      instagram: 'Instagram',
      facebook: 'Facebook',
      youtube: 'YouTube',
    },
  },

  // CTA Section
  cta: {
    title: 'Ready to Experience It?',
    subtitle: 'Book your race now and discover the unique thrills of Aqua-Rush.',
    button: 'Book Now',
    or: 'or',
    moreInfo: 'Learn More',
    securePayment: 'Secure payment',
    freeCancellation: 'Free cancellation',
    rating: '4.9/5 on Google',
    question: 'Any questions?',
  },

  // Footer
  footer: {
    tagline: 'Boat Racing Experience - The unique FPV racing experience!',
    navigation: 'Navigation',
    info: 'Information',
    legal: 'Legal notice',
    terms: 'Terms & Conditions',
    privacy: 'Privacy policy',
    rights: 'All rights reserved.',
    madeWith: 'Made with',
    inCorsica: 'in Corsica',
  },

  // Cockpit App
  cockpit: {
    dashboard: 'Dashboard',
    race: 'Race',
    queue: 'Queue',
    boats: 'Boats',
    register: 'Register',
    kpis: 'KPIs',
    clients: 'Clients',
    team: 'Team',
    screens: 'Screens',
    settings: 'Settings',
    greeting: 'Hello',
    todayRaces: 'Today\'s races',
    participants: 'Participants',
    revenue: 'Today\'s revenue',
    fillRate: 'Fill rate',
    vsYesterday: 'vs yesterday',
    quickActions: 'Quick actions',
    startRace: 'Start a race',
    addToQueue: 'Add to queue',
    todayPlanning: 'Today\'s planning',
    currentRace: 'Current race',
    finished: 'Finished',
    scheduled: 'Scheduled',
    connected: 'Connected',
    offline: 'Offline',
    raceInProgress: 'Race in progress',
    participantsReady: 'participants ready',
    peopleWaiting: 'people waiting',
    boatStatus: {
      available: 'Available',
      inUse: 'In Race',
      charging: 'Charging',
      maintenance: 'Maintenance',
    },
    actions: {
      call: 'Call',
      remove: 'Remove',
      startRace: 'Start',
      stopRace: 'Stop',
      pauseRace: 'Pause',
    },
  },

  // Displays App
  displays: {
    raceLeaderboard: 'Race Leaderboard',
    liveUpdates: 'Live Updates',
    raceTime: 'Race Time',
    noParticipants: 'No participants',
    waitingForRace: 'Waiting for start...',
    position: 'Position',
    pilot: 'Pilot',
    boat: 'Boat',
    laps: 'Laps',
    bestLap: 'Best lap',
    lastLap: 'Last lap',
    gap: 'Gap',
    raceControl: 'Race Control',
    leader: 'Leader',
    finished: 'Finished',
    dnf: 'DNF',
  },

  // Franchise App
  franchise: {
    title: 'Become an FPV Franchisee',
    subtitle: 'The revolution in aquatic entertainment',
    launchCenter: 'Launch your FPV boat racing center and generate significant revenue.',
    uniqueOpportunity: 'A unique opportunity in an exponentially growing sector.',
    discoverOpp: 'Discover the opportunity',
    bookMeeting: 'Book a meeting',
    sitesOperating: 'Sites operating',
    participantsMonth: 'Participants/month',
    avgROI: 'Average ROI',
    advantages: 'Advantages',
    faq: 'FAQ',
    contact: 'Contact',
    franchiseeArea: 'Franchisee Area',
    apply: 'Apply',
    turnkey: 'Turnkey',
    turnkeyDesc: 'Complete installation with training and ongoing support',
    digitalEco: 'Digital ecosystem',
    digitalEcoDesc: 'Proprietary applications included (cockpit, displays, client)',
    exclusivity: 'Territorial exclusivity',
    exclusivityDesc: 'Protected geographic area to maximize your potential',
    support: '24/7 Support',
    supportDesc: 'Dedicated team to assist you daily',
    advantagesDesc: 'Why join the Aqua-Rush network',
    faqDesc: 'Frequently asked questions from franchisees',
    contactDesc: 'Contact our franchise team',
    conceptDesc: 'A unique FPV boat racing concept',
    howItWorks: 'How it works',
    businessModel: 'Business model',
    businessModelDesc: 'A proven and profitable business model',
    revenueSource: 'Revenue sources',
    marginEvolution: 'Margin evolution',
    investmentAndFees: 'Investment and fees',
    phone: 'Phone',
    email: 'Email',
    response24h: 'Response within 24h',
    address: 'Address',
    headquarters: 'Headquarters',
    thank: 'Thank you!',
    successMessage: 'Your request has been sent. We will contact you shortly.',
    fullName: 'Full name',
    city: 'City',
    message: 'Message',
    messagePlaceholder: 'Tell us about your project...',
    sending: 'Sending...',
    submit: 'Submit application',
    investment: {
      title: 'Investment',
      initial: 'Initial contribution',
      roi: 'Estimated ROI',
      payback: 'Return on investment',
      recommended: 'Recommended',
      timeline: 'Investment timeline',
    },
    dashboard: {
      welcome: 'Welcome',
      yourSite: 'Your site',
      todayStats: 'Today\'s statistics',
      monthStats: 'This month',
      yearStats: 'This year',
    },
  },

  // Time
  time: {
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    thisWeek: 'This week',
    thisMonth: 'This month',
    minutes: 'min',
    hours: 'h',
    days: 'd',
    ago: 'ago',
  },

  // Errors
  errors: {
    generic: 'An error occurred',
    network: 'Connection error',
    notFound: 'Page not found',
    unauthorized: 'Unauthorized access',
    serverError: 'Server error',
    tryAgain: 'Try again',
  },
};
